document.addEventListener("DOMContentLoaded", function () {
  var reviewsContainer = document.getElementById("reviews-container");

  var xhr = new XMLHttpRequest();
  xhr.open("GET", "https://admin.grabmycontact.com/webhooks/review_fetch.php?sku="+productID, true); // Replace with the actual URL to your reviews JSON endpoint
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var data = JSON.parse(xhr.responseText);
      var reviewsHTML = "";

      data.forEach(function (review) {
        // Generate stars based on the rating
        var starRatingHTML = "";
        for (var i = 0; i < review.stars; i++) {
          starRatingHTML += '<span class="star">&#9733;</span>'; // You can use your own star icon or HTML entity
        }

        reviewsHTML += `
          <div class="col-md-6">
            <div class="review-list__item">
              <div class="review-list__thumb"> <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M480 256C480 132.3 379.7 32 256 32S32 132.3 32 256c0 67.5 29.8 128 77 169l35-105H368l35 105c47.2-41.1 77-101.6 77-169zM376 445.2L344.9 352H167.1L136 445.2c34.7 22 75.9 34.8 120 34.8c44.5 0 85.9-13 120.7-35.3l-.7 .5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208-48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"/></svg> </div>
              <div class="review-list__author">${review.name}</div>
              <div class="review-list__star-rating">${starRatingHTML}</div>
              <div class="review-list__star-item">${review.product}</div>
              <div class="review-list__comment">${review.review}</div>       
            </div>
          </div>
        `;
      });

      reviewsContainer.innerHTML = reviewsHTML;
    } else if (xhr.status !== 200) {
      console.error("Failed to fetch reviews via AJAX.");
    }
  };

  xhr.send();
});
